/* BRIORA P36 (handoff 2.86) · Tarjetas de producto sobre fondo oscuro.
   Las tarjetas llevan los colores de su marca (assets/briora-marcas.css), pensados para fondo claro: precio gris en
   Joyería Briora y tabaco en FINO. Si una tarjeta cae en una sección oscura (p. ej. «Las joyas más deseadas» de la
   portada, fondo #5d4b3c), aquí se le pone data-bm-fondo="oscuro" y el CSS usa el color de texto de la sección.
   El fondo se lee de las variables que el tema da a cada sección (--color-background-rgb o --color-background) y
   que la tarjeta hereda. Las tarjetas que llegan después (recomendaciones, filtros, editor del tema) se marcan
   con un MutationObserver. */
(function () {
  'use strict';

  var SELECTOR = 'product-card[data-brand]:not([data-bm-fondo])';

  function backgroundOf(el) {
    var cs = getComputedStyle(el);
    var rgb = cs.getPropertyValue('--color-background-rgb').trim();
    if (rgb) {
      var parts = rgb.split(/[\s,\/]+/).slice(0, 3).map(Number);
      if (parts.length === 3 && parts.every(function (n) { return !isNaN(n); })) return parts;
    }
    var color = cs.getPropertyValue('--color-background').trim();
    var hex = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(color);
    if (hex) {
      var h = hex[1].length === 3 ? hex[1].replace(/./g, '$&$&') : hex[1];
      return [0, 2, 4].map(function (i) { return parseInt(h.substr(i, 2), 16); });
    }
    var fn = /^rgba?\(([^)]+)\)$/i.exec(color);
    if (fn) {
      var values = fn[1].split(/[\s,\/]+/).slice(0, 3).map(Number);
      if (values.length === 3 && values.every(function (n) { return !isNaN(n); })) return values;
    }
    return null;
  }

  // Luminancia relativa (WCAG): por debajo de 0,179 se lee mejor el texto claro que el oscuro.
  function isDark(rgb) {
    var lin = rgb.map(function (c) {
      c /= 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * lin[0] + 0.7152 * lin[1] + 0.0722 * lin[2] < 0.179;
  }

  function mark() {
    var cards = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < cards.length; i++) {
      var rgb = backgroundOf(cards[i]);
      cards[i].setAttribute('data-bm-fondo', rgb && isDark(rgb) ? 'oscuro' : 'claro');
    }
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      mark();
    });
  }

  mark();
  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', queue);
})();
